import { useState } from "react";

import { Button, Table } from "antd";
import { ColumnsType } from "antd/es/table";

import {
  ContractorContactEditModal,
  ContractorContactDeleteModal,
} from "components/contractors";
import { Loading } from "components/common";
import { IClient } from "store/userManagement/userManagement.types";
import deleteIcon from "data/icons/trash.svg";
import editIconBlue from "data/icons/edit-blue.svg";
import "components/cases/CasesTable/CasesTable.scss";

import "./ContractorContactListTable.scss";

interface IProps {
  contactsList: any[];
  getContactsList: () => void;
}

const ContractorContactListTable = ({
  contactsList,
  getContactsList,
}: IProps) => {
  const [ editingContact, setEditingContact ] = useState<any>(null);
  const [ deletingContact, setDeletingContact ] = useState<any>(null);

  const onContactEdit = (user: IClient) => {
    setEditingContact(user);
  };

  const onContactDelete = (user: IClient) => {
    setDeletingContact(user);
  };

  const columns: ColumnsType<IClient> = [
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
      render: (value) => <p className="active thin">{ value }</p>,
      width: "9%",
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
      width: "9%",
      render: (value) => <p className="active thin">{ value }</p>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "16%",
      render: (value) => <p className="active thin">{ value }</p>,
    },
    {
      title: "Phone",
      dataIndex: "phone_number",
      key: "phone_number",
      width: "14%",
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: "2%",
      render: (_value, item) => (
        <div style={ { display: "flex", gap: 10 } }>
          <Button
            type="text"
            size="small"
            className="team-table-delete-button"
            icon={ <img src={ editIconBlue } alt=""/> }
            onClick={ () => onContactEdit(item) }
          >
          </Button>

          <Button
            type="text"
            size="small"
            className="team-table-delete-button"
            icon={ <img src={ deleteIcon } alt=""/> }
            onClick={ () => onContactDelete(item) }
          >
          </Button>
        </div>
      ),
    },
  ];

  return (
    <Loading
      isLoading={ false }
      isColored
      isFullWidth
      height={ 200 }
    >
      <Table
        className="cases-table user-management-table"
        columns={ columns }
        dataSource={ contactsList }
        pagination={ false }
        rowKey={ item => item.id }
        scroll={ { y: window.innerHeight - 183 - (document.getElementById("user-management-header-cell")?.offsetHeight || 0) } }
        tableLayout="auto"
      />

      <ContractorContactEditModal
        editingContact={ editingContact }
        setEditingContact={ setEditingContact }
        getContactsList={ getContactsList }
      />

      <ContractorContactDeleteModal
        deletingContact={ deletingContact }
        setDeletingContact={ setDeletingContact }
        getContactsList={ getContactsList }
      />
    </Loading>
  );
};

export default ContractorContactListTable;
